
function getBaseTemplate(innerContent) {
  return `
  <div style="background:#f4f4f4;padding:40px 0;">
    <div style="max-width:650px;margin:auto;background:#fff;border-radius:10px;overflow:hidden;">
      
      <div style="height:120px;background:linear-gradient(to right,#2ec4b6,#66bb2a);"></div>

      <div style="padding:30px;text-align:center;">
        ${innerContent}

        <div style="margin-top:30px;background:#eee;padding:15px;">
          <span style="color:#4CAF50;">Award Suite</span> -Judging System Simplified!!
        </div>
      </div>
    </div>
  </div>
  `;
}
export const templateData = [
  {
    id: 0,
    name: "Collaborator Invitation",
    subject: "Collaboration for {{event.name}}",
    content: getBaseTemplate(`
      <h2>{{event.name}}</h2>
      <p>Hi {{user.lastname}}, {{user.firstname}},</p>
      <p>We are thrilled to invite you for collaboration in <b>{{event.name}}</b>.</p>
      <p>Best Regards,<br/><b>{{event.name}} Team</b></p>
    `),
  },

  {
    id: 1,
    name: "Registration Acknowledgement",
    subject: "Registration Successful",
    content: getBaseTemplate(`
      <h2>{{event.name}}</h2>
      <h3 style="color:#3f51b5;">Registration Successful</h3>
      <p>Hi {{entrant.firstname}} {{entrant.lastname}},</p>
      <p>This email confirms that you are now registered for {{event.name}}.</p>
      <p>Thank you for joining!</p>
      <br/>
      <a style="background:#4CAF50;color:white;padding:10px 20px;text-decoration:none;border-radius:4px;">
        Click here to log in
      </a>
      <p><b>{{event.name}} Team</b></p>
    `),
  },

  {
    id: 2,
    name: "Endorsement",
    subject: "Client Endorsement Request",
    content: getBaseTemplate(`
      <h2>{{event.name}}</h2>
      <h3>Client Endorsement Request</h3>
      <p>{{submission.id}}</p>
      <p>Hi,</p>
      <p>{{entrant.firstname}} {{entrant.lastname}} submitted <b>{{submission.title}}</b></p>
      <p>Category: {{submission.category}}</p>
      <br/>
      <a style="background:green;color:white;padding:10px 20px;margin-right:10px;">Yes</a>
      <a style="background:#00bcd4;color:white;padding:10px 20px;">Mail to Entrant</a>
    `),
  },

  {
    id: 3,
    name: "Submission Details",
    subject: "Submission Received",
    content: getBaseTemplate(`
      <h2 style="text-align:center">{{event.name}}</h2>
      <p>Hi {{entrant.firstname}} {{entrant.lastname}},</p>
      <p>Your submission has been received.</p>
      <p>{{submission.details}}</p>
      <p><a href="#">Click here</a> to edit or upload your submission.</p>
    `),
  },

  {
    id: 4,
    name: "Pending Payment Notification",
    subject: "Pending Payment",
    content: getBaseTemplate(`
      <h2>{{event.name}}</h2>
      <h3>Order ID : {{order.order_ref_no}}</h3>
      <p>Your payment is pending. Please complete payment.</p>
      <h4>Order Info</h4>
      <p>{{order.orderlist}}</p>
      <h4>Submissions Details</h4>
      <p>{{order.submissionlist}}</p>
      <p>{{payment.information}}</p>
    `),
  },

  {
    id: 5,
    name: "Order Acknowledgement",
    subject: "Order Acknowledgement",
    content: getBaseTemplate(`
      <h2>{{event.name}}</h2>
      <h3>Order ID : {{order.order_ref_no}}</h3>
      <p>Thank you for your submission.</p>
      <p>Your payment is still pending.</p>
      <h4>Order Info</h4>
      <p>{{order.orderlist}}</p>
      <h4>Submissions Details</h4>
      <p>{{order.submissionlist}}</p>
      <p>{{payment.information}}</p>
    `),
  },

  {
    id: 6,
    name: "Order Confirmation",
    subject: "Order Confirmation",
    content: getBaseTemplate(`
      <h2>{{event.name}}</h2>
      <h3>Order ID : {{order.order_ref_no}}</h3>
      <p>Your submission is confirmed.</p>
      <h4>Order Info</h4>
      <p>{{order.orderlist}}</p>
      <h4>Submissions Details</h4>
      <p>{{order.submissionlist}}</p>
      <p>{{payment.information}}</p>
    `),
  },

  {
    id: 7,
    name: "Judge Invitation",
    subject: "Invitation to Judge",
    content: getBaseTemplate(`
      <h2>{{event.name}}</h2>
      <h3>Invitation to Judge</h3>
      <p>Hi {{judge.firstname}} {{judge.lastname}}</p>
      <p>You are invited to judge {{event.name}}</p>
      <br/>
      <a style="background:green;color:white;padding:10px 20px;margin-right:10px;">Start Judging</a>
      <a style="background:#c89b00;color:white;padding:10px 20px;">Contact Organizer</a>
    `),
  },
];